import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import { App } from './App'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from '@Root/store'
import { changeDefaultMomentOptions } from '@Root/configs'
import { loadTei } from '@Root/tei'
import * as serviceWorker from './serviceWorker'

const render = () =>
  ReactDOM.render(
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>,
    document.getElementById('root')
  )

// The TEI manifest drives field visibility and labels everywhere, so it is loaded before the first render.
// If the API is down the app still renders with the empty manifest (all core fields, no features).
loadTei().catch(error => console.error('Failed to load TEI manifest', error)).finally(render)

changeDefaultMomentOptions()

serviceWorker.unregister()
